import { getLocalStorageValue } from "./localStorage"
import { retrieveDataFromApi } from "./api"

const LOCAL_STORAGE_KEY = "data"

// Start: helper functions
function isNewFunnelFoxSession(params) {
  const localFFSessionId = getLocalStorageValue(LOCAL_STORAGE_KEY, "ff-session-id")
  const ffSessionId = params["ff-session-id"]

  if ((!localFFSessionId && !ffSessionId) || ffSessionId === "{{ff_session_id}}") {
    const ffOrigin = params["ff-origin"]
    const ffOriginPath = params["ff-origin-path"]

    if (ffOriginPath && ffOrigin) {
      window.location = `${ffOrigin}/${ffOriginPath}`
      return
    }

    const hashParams = new URLSearchParams(window.location.hash.substr(1))
    const translationToken = hashParams.get("translation_token")
    if (translationToken) {
      return
    }

    throw new Error("[FunnelFox] Missing ff origin or its path or ff session id")
  }

  return ffSessionId && localFFSessionId !== ffSessionId
}

function isNewFunnelFoxOfferSelected(params) {
  const localActiveOffer = getLocalStorageValue(LOCAL_STORAGE_KEY, "activeOffer")
  const ffOfferPPOId = params["ff-ppo-id"]
  const ffOfferId = params["ff-offer-id"]
  const isPPOOffer =
    typeof ffOfferPPOId !== "undefined" && ffOfferPPOId !== "undefined" && ffOfferPPOId !== "null"
  const paramsOfferId = isPPOOffer ? ffOfferPPOId : ffOfferId

  if (!localActiveOffer && paramsOfferId) {
    return true
  }
  // If PPO offer is selected, check if the active offer from PPO field is different
  if (isPPOOffer) {
    return (
      localActiveOffer && paramsOfferId && localActiveOffer.priceProductObjectId !== paramsOfferId
    )
  }

  return (
    localActiveOffer &&
    paramsOfferId &&
    localActiveOffer.brandOfferId !== parseInt(paramsOfferId, 10)
  )
}

function setActiveOfferFromUrl(paramsOfferId, isPPOOffer) {
  try {
    let preselctedOffer
    if (isPPOOffer) {
      // Retrieve offer by priceProductObjectId
      preselctedOffer = pipelineConfig.offers.find(
        (offer) => offer.priceProductObjectId === paramsOfferId,
      )
    } else {
      // Retrieve offer by brandOfferId
      preselctedOffer = pipelineConfig.offers.find(
        (offer) => offer.brandOfferId === parseInt(paramsOfferId, 10),
      )
    }
    // Throw error if the offer is not found
    if (!preselctedOffer) {
      throw new Error(`[FunnelFox] Offer not found - id: ${paramsOfferId}`)
    }

    return preselctedOffer
  } catch (e) {
    console.error(e)
    return
  }
}

// Needed due to issue that CPPv3 order on createion via FunnelFox doesn't save these values
// Meaning, later after data polling the datastora values are combination of :
// - dataStore.intialValues()
// - CPPv3 BE order response
// - query parameters passed from FunnelFox pipeline
function addFFValuesToDataStore(params, dataStore) {
  try {
    const ffSessionId = params["ff-session-id"] //Used for FunnelFox
    const ffOrigin = params["ff-origin"] //Used for FunnelFox
    const ffOriginPath = params["ff-origin-path"] //Used for FunnelFox
    const ffOfferPPOId = params["ff-ppo-id"] //Used for FunnelFox - nnp offers
    const ffOfferId = params["ff-offer-id"] //Used for FunnelFox - app offers
    const ffExitIntentPath = params["ff-exit-intent-path"] //Used for FunnelFox
    const isPPOOffer =
      typeof ffOfferPPOId !== "undefined" && ffOfferPPOId !== "undefined" && ffOfferPPOId !== "null"
    const paramsOfferId = isPPOOffer ? ffOfferPPOId : ffOfferId
    const activeOffer = setActiveOfferFromUrl(paramsOfferId, isPPOOffer)

    dataStore.values = {
      ...dataStore.values,
      ffSessionId,
      ffOrigin,
      ffOriginPath,
      ffOfferPPOId,
      ffOfferId,
      ffExitIntentPath,
      activeOffer,
      ffInitialFetch: true,
    }
  } catch (e) {
    console.error(e)
  }
}
// End: helper functions

// Start: Exported functions
export async function getFunnelFoxOrderData(params, dataStore) {
  if (isNewFunnelFoxSession(params) || isNewFunnelFoxOfferSelected(params)) {
    addFFValuesToDataStore(params, dataStore)
    await retrieveDataFromApi(dataStore)

    return
  }
}

export function isFunnelFoxPipeline() {
  if (!pipelineConfig) {
    return false
  }
  if (!pipelineConfig.isFunnelFoxPipe) {
    return false
  }

  return true
}

export function getFunnelFoxDataValues(initialValues, storeValues) {
  // Needed, otherwise we don't have initial values coming from FF order
  if (storeValues.ffInitialFetch) {
    const queryParamValues = {
      ffSessionId: storeValues.ffSessionId,
      ffOrigin: storeValues.ffOrigin,
      ffOriginPath: storeValues.ffOriginPath,
      ffOfferPPOId: storeValues.ffOfferPPOId,
      ffExitIntentPath: storeValues.ffExitIntentPath,
      activeOffer: storeValues.activeOffer,
    }
    // Combine - intial dataStore values + funnel-fox query params + later data from API, meaning, order
    storeValues = {
      ...initialValues,
      ...queryParamValues,
      ffInitialFetch: false,
    }
  }

  return storeValues
}
